import React from 'react';
import projectsInfo from '../ProjectsInfo';
import { Link } from 'react-router-dom';
import TrackVisibility from 'react-on-screen';
import './ProjectGrid.css';
import {ReactComponent as ProjectCardArrowIcon} from "../../../assets/icon/projectCardArrowIcon.svg";


// Project card component
export const ProjectCard = ({ id, showcaseImg, showcasename }) => {
    const imageSrc = require(`../../../assets/img/${showcaseImg}`);

    return (
        <div className='project-card__container'>
            <Link to={`/projects/${id}`}>
                <div className={`project-card animate__animated animate__fadeIn`} style={{ backgroundImage: `url(${imageSrc})` }}>
                        <div className='project-card__button-icon'>
                            <ProjectCardArrowIcon/>
                        </div>
                        <h2 className={`project-card__title `}>{showcasename}</h2>
                </div>
            </Link>   
        </div>
    );
};

export const ProjectGrid = () => {
    return (
        <TrackVisibility once>
            {({ isVisible }) =>
                <div className={`project-grid`}>
                    <div className={`project-grid__title ${isVisible ? 'animate__animated animate__fadeInUp' : ''}`}>
                        <h1>Past Projects</h1>
                        <p>Legacy of Excellence</p>
                    </div>
                    <div className={`project-grid__cards-container ${isVisible ? 'animate__animated animate__fadeIn' : ''}`}>
                        {projectsInfo.map(project => (
                            <ProjectCard
                                key={project.id}
                                id={project.id}
                                showcaseImg={project.showcaseImg}
                                showcasename={project.showcaseName}
                            />
                        ))}
                    </div>
                </div>
            }
        </TrackVisibility>
    );
};